// hooks/useModalMenuContext.tsx
import React, { createContext, useContext, useState, ReactNode, useMemo } from 'react';

export interface ModalMenuContextType {
    openElements: string[];
    setOpenElements: (elements: string[]) => void;
    activeTree: string[];
    setActiveTree: (tree: string[]) => void;
}

export const ModalMenuContext = createContext<ModalMenuContextType | undefined>(undefined);

export interface ModalMenuProviderProps {
    children: ReactNode;
}

export const ModalMenuProvider: React.FunctionComponent<ModalMenuProviderProps> = function ({
    children,
}) {
    const [openElements, setOpenElements] = useState<string[]>([]);
    const [activeTree, setActiveTree] = useState<string[]>([]);

    const value = useMemo(
        () => ({
            openElements,
            setOpenElements,
            activeTree,
            setActiveTree,
        }),
        [activeTree, openElements],
    );

    return <ModalMenuContext.Provider value={value}>{children}</ModalMenuContext.Provider>;
};

export const useModalMenuContext = (): ModalMenuContextType => {
    const context = useContext(ModalMenuContext);
    if (!context) {
        throw new Error('useModalMenuContext must be used within a ModalMenuProvider');
    }
    return context;
};
